import { LOCALES } from 'services/utils'

const isMatched = (attr, q) => (attr || '').toLowerCase().indexOf(q) > -1;

const documentGroupMatched = (documentGroup, q) => {
    if (typeof documentGroup.name == 'object') {
        return isMatched(documentGroup.name[LOCALES.current], q) || isMatched(Object.entries(documentGroup.name)[0], q)
    } else {
        return isMatched(documentGroup.name, q)
    }
}

const search = (list, q) => {
    if (q === '' || q === null) {
        return [].concat(list);
    }
    return list.filter(documentGroup => documentGroupMatched(documentGroup, q.toLowerCase()));
}

export default () => ({
    restrict: 'E',
    template(element) {
        return `
    <div>
      <div class="row">
        <div class="col-xs-3">
          <ng-search-line callback="search"/>
        </div>
      </div>
      ${element.html()}
    </div>
`;
    },
    replace: true,
    scope: true,
    controller: ['$scope', '$attrs', ($scope, $attrs) => {
        let list = $scope.$eval($attrs.list);

        $scope.search = q => {
            $scope.searchResult.length = 0;
            $scope.searchResult.push(...search(list, q));
        }

        $scope.searchResult = [];
        $scope.search('');
    }]
})
